import { createSlice } from '@reduxjs/toolkit';

const kidInitialState = {
  selectedKid: null,
};

const kidSlice = createSlice({
  name: 'kid',
  initialState: kidInitialState,
  reducers: {
    selectKid: (state, action) => {
      state.selectedKid = action.payload;
    },
    deselectKid: (state) => {
      state.selectedKid = null;
    },
  },
});

export const { selectKid, deselectKid } = kidSlice.actions;
export default kidSlice.reducer;